export const personalData = {
  name: "Eslam Ahmed Hassan",
  shortName: "Eslam Ahmed",
  profile:
    "https://res.cloudinary.com/dyv3dluov/image/upload/v1731782506/portfolio/esarihtrv3y86twshgoh.jpg",
  designation: "Frontend Developer",
  roles: [
    "Frontend Developer",
    "Full Stack Developer",
    "React & Next.js Engineer",
  ],
  description:
    "Frontend Developer with hands-on experience building responsive, accessible web applications using React.js, Next.js, and TypeScript. Delivered production projects including a cybersecurity SaaS platform and an enterprise GRC system, with a 30% Lighthouse score improvement and a 40% increase in booking efficiency.",
  about:
    "I build production-grade web apps with React, Next.js, and TypeScript — from SaaS dashboards to multilingual marketing sites. I care about clean, scalable UI, measurable performance, and shipping with Agile teams. I have also mentored 150+ students through structured frontend workshops.",
  email: "eslam.ahmed.hassn90@gmail.com",
  phone: "+20 101 296 6375",
  address: "Cairo, Egypt",
  github: "https://github.com/RXROW",
  facebook: "https://www.facebook.com/eslam.almasody?mibextid=ZbWKwL",
  linkedIn: "https://www.linkedin.com/in/rxrow/",
  twitter: "https://twitter.com",
  whatsapp: "https://wa.me/201012966375",
  resume:
    "https://drive.google.com/file/d/1d6ruuSpPr1I6-XosPklVWZwkQzHi0V9O/view?usp=sharing",
  education: {
    degree: "Bachelor's Degree in Computer Science",
    gpa: "3.2",
    school:
      "Higher Institute of Computer Science & Information Systems – El Obour Institutes",
    year: "2025",
  },
  languages: ["Arabic (Native)", "English (Very Good)"],
};
